module.exports = __webpack_public_path__ + "img/SS.3208b1fd.png";